import React from "react"

import {Card} from "@components/index"

export default function UserStats() {


    return <Card title="Your Stats">
        Your stats will be shown below
    </Card>
}